.overlay {
  position: fixed;
  inset: 0;
  z-index: 70;
  display: grid;
  place-items: center;
  padding: 16px;
  background: var(--scrim);
}

.overlay[data-entering] {
  animation: fade var(--dur-fast) ease-out;
}

@keyframes fade {
  from {
    opacity: 0;
  }
}

.modal {
  width: min(520px, 100%);
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  border-radius: var(--radius-md);
  background: var(--white);
  box-shadow: var(--shadow-dialog);
}

/* With a step in place of the reason (APP-148), the dialog takes the step's width. */
.modalWide {
  width: min(760px, 100%);
}

.modal::before {
  content: '';
  display: block;
  height: 4px;
  background: var(--gradient-rule);
}

.dialog {
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 24px 28px 28px;
  outline: none;
}

.title {
  color: var(--text-heading);
  font-size: 24px;
  line-height: 1.15;
  letter-spacing: 0.02em;
}

.intro {
  margin: 0;
  color: var(--text-secondary);
  font-size: 15px;
  line-height: 1.6;
}

.summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1.2fr);
  gap: 0;
  margin: 0;
  border: 1px solid var(--border-card);
  border-radius: var(--radius-sm);
}

.summary dt,
.summary dd {
  min-width: 0;
  margin: 0;
  padding: 10px 14px;
  border-bottom: 1px solid var(--border-hairline);
  font-size: 14px;
  overflow-wrap: anywhere;
}

.summary dt {
  color: var(--text-secondary);
}

.summary dd {
  color: var(--text-heading);
  font-weight: var(--fw-bold);
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.row {
  display: contents;
}

.row:last-child dt,
.row:last-child dd {
  border-bottom: 0;
}

.formBody {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.before {
  color: var(--text-muted);
  font-weight: var(--fw-regular);
  text-decoration: line-through;
}

.arrow {
  display: inline-block;
  margin: 0 6px;
  vertical-align: -2px;
  color: var(--text-muted);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 10px;
}

/* Why the change didn't go through; the dialog stays open so it can be fixed. */
.error {
  margin: 0;
  padding: 10px 14px;
  border-left: 3px solid var(--status-problem-ink);
  border-radius: var(--radius-sm);
  background: var(--status-problem-bg);
  color: var(--status-problem-ink);
  font-size: 14px;
  line-height: 1.5;
}
